import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import i18n from "./i18n";
import ShHelper from "./plugins/sh-helper";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";

import "./assets/scss/custom.scss";
import store from "./store";

import Amplify, * as AmplifyModules from "aws-amplify";
import awsconfig from "./aws-exports";
Amplify.configure(awsconfig);

Vue.config.productionTip = false;

export const i18nConfig = i18n;

// Install BootstrapVue
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);
// Add Self made Schindelhauer Helper
Vue.use(ShHelper, { i18n: i18n });
// Add AWS Amplify
Vue.use(AmplifyModules);

new Vue({
  router,
  i18n,
  ShHelper,
  store,
  render: h => h(App)
}).$mount("#app");
